const wpsUserIds = [
  //测试环境账号
  '284109089',
  //正式环境账号
  '1562054737',
  '1388246555',
  '1388382587',
  '1385943716',
]

const seasungamesUserIds = [
  '1490018435', 
  '1498736759', // 超管
]

// apikey 配置页授权用户
export const AuthenticatedUser = [
  ...wpsUserIds,
  ...seasungamesUserIds,
]

// 模型厂商code
export const VENDORS = {
  moka: 'moka'
}
